<div class="dropdown" [ngSwitch]="type">
  @if (isEditMode) {
    <mat-checkbox
      id="dropdown-highlights-checkbox"
      [checked]="editModeSelections?.allSelected"
      [indeterminate]="editModeSelections?.someSelected && !editModeSelections?.allSelected"
      (change)="allAnnotationsSelected.emit($event.checked)"
      aria-label="Select {{ getTitleTranslation(type) | translate }}"
    ></mat-checkbox>
  }

  @switch (type) {

    <!-- Highlight Dropdown -->
    @case (MaterialAnnotationType.HIGHLIGHTS) {
      <button mat-button [matMenuTriggerFor]="belowMenu">
        <div class="dropdown-button">
          <span class="filter-title">{{ getTitleTranslation(type) | translate }}</span>
          <span class="arrow-down-icon"></span>
        </div>
      </button>
      <mat-menu class="contents-dropdown" #belowMenu="matMenu" yPosition="below">
        <button
          mat-menu-item
          [ngClass]="{ 'active-item': dropdownState === MaterialDropdownState.ALL }"
          (click)="handleAllAnnotationsSelected()">
          {{ 'contents.dropdown_all_highlights' | translate }}
        </button>
        <button
          mat-menu-item
          [ngClass]="{ 'active-item': dropdownState === MaterialDropdownState.DETACHED }"
          (click)="handleDetachedAnnotationsSelected()">
          {{ 'contents.dropdown_detached_highlights' | translate }}
        </button>
      </mat-menu>
    }

    <!-- Notes Dropdown -->
    @case (MaterialAnnotationType.NOTES) {
      <button mat-button [matMenuTriggerFor]="belowMenu">
        <div class="dropdown-button">
          <span class="filter-title">{{ getTitleTranslation(type) | translate }}</span>
          <span class="arrow-down-icon"></span>
        </div>
      </button>
      <mat-menu class="contents-dropdown" #belowMenu="matMenu" yPosition="below">
        <button
          mat-menu-item
          [ngClass]="{ 'active-item': dropdownState === MaterialDropdownState.ALL }"
          (click)="handleAllAnnotationsSelected()">
          {{ 'contents.dropdown_all_notes' | translate }}
        </button>
        <button
          mat-menu-item
          [ngClass]="{ 'active-item': dropdownState === MaterialDropdownState.DETACHED }"
          (click)="handleDetachedAnnotationsSelected()">
          {{ 'contents.dropdown_detached_notes' | translate }}
        </button>
      </mat-menu>
    }

    <!-- Placemarks Dropdown -->
    @case (MaterialAnnotationType.PLACEMARKS) {
      <button mat-button [matMenuTriggerFor]="belowMenu">
        <div class="dropdown-button">
          <span class="filter-title">{{ getTitleTranslation(type) | translate }}</span>
          <span class="arrow-down-icon"></span>
        </div>
      </button>
      <mat-menu class="contents-dropdown" #belowMenu="matMenu" yPosition="below">
        <button
          mat-menu-item
          [ngClass]="{ 'active-item': dropdownState === MaterialDropdownState.ALL }"
          (click)="handleAllAnnotationsSelected()">
          {{ 'contents.dropdown_all_placemarks' | translate }}
        </button>
        <button
          mat-menu-item
          [ngClass]="{ 'active-item': dropdownState === MaterialDropdownState.DETACHED }"
          (click)="handleDetachedAnnotationsSelected()">
          {{ 'contents.dropdown_detached_placemarks' | translate }}
        </button>
      </mat-menu>
    }
  }
</div>
